import React, {PureComponent} from "react"

import id from "@irati/utils/id"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {Wallet} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"

import {TabTypes} from "../../enums"
import {StyledStatementItems, DesktopHeader} from "./styled"

interface Props extends InjectIntl {
  isPhone: boolean,
  selectedTab: TabTypes,
  onTabChange: (selectedTab: TabTypes) => void,
  wallet: Wallet
}

class FlexiPoints extends PureComponent<Props> {
  render() {
    const idNamespace = id("balances", this.props)
    const {wallet} = this.props

    return (
      <Spacing marginTop={4}>
        <DesktopHeader marginBottom={2}>
          <FormattedMessage id="wallet.transactions.title.flexiPoints" />
        </DesktopHeader>
        <StyledStatementItems id={idNamespace} wallet={wallet} />
      </Spacing>
    )
  }
}

export default injectIntl(FlexiPoints)
